module.exports = __webpack_public_path__ + "img/txt.942b9c40.png";